import { Component, OnInit, Input, SimpleChanges ,OnDestroy} from '@angular/core';

import { LoadingScreenService } from "./services/loader.service";


//import * as anime from 'animejs';

@Component({
  selector: 'Adahi-loader',
  templateUrl: './loader.component.html',
  styleUrls: []
})
export class LoaderComponent implements OnInit {


  loading: boolean =false;
  //#endregion

  //#region constructor
  constructor(public LoadingScreenService:LoadingScreenService) { }
  //#endregion

  ngOnInit() {
    this.LoadingScreenService.loading;
     
  }

  ngOnChanges(changes: SimpleChanges) 
  {
    
    
  }

  ngOnDestroy() {

  }
}
